import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/sacrifice-bunt
// A sacrifice fly occurs when a batter hits a fly-ball out to the outfield or foul territory that allows a runner to score. The batter is given credit for an RBI. (If the ball is dropped for an error but it is determined that the runner would have scored with a catch, then the batter is still credited with a sacrifice fly.)
// @see https://www.mlb.com/glossary/standard-stats/sacrifice-fly
// A plate appearance refers to a batter's turn at the plate. Each completed turn batting is one plate appearance. Plate appearances can often be confused with at-bats. But unlike with at-bats -- which only occur on certain results -- a plate appearance takes into account every single time a batter comes up and a result between batter and pitcher is obtained.
const classifiesAsSacrifice = function(paResult) {
    switch (paResult) {
        // batter out, sacrifice
        case PlateAppearanceResult.SacrificeBunt.key:
        case PlateAppearanceResult.SacrificeFly.key:
        case PlateAppearanceResult.SacrificePlay.key:
        // batter safe - other
        case PlateAppearanceResult.SacrificeOnError.key:
        case PlateAppearanceResult.SacrificeOnFieldersChoice.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsSacrifice;